import { useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { SubmitButton } from "ui-components/Form";
import { Layout } from "ui-components/Layout";
import { Success, Error } from "ui-components/Alert";
import { formRender, initialValues, changePasswordValidation } from "./change-password-schema";
import { changePassword } from "services/data.auth.service";
import ChangePasswordInfo from "./components/ChangePasswordInfo";
import { LoadingDialog } from "ui-components/Alert";
import { useAuth } from "auth/authProvider";

function ChangeUserPassword() {
  const [alert, setAlert] = useState(null);
  const [loading,setLoading] = useState(false)
  const onError = (data) => setAlert(<Error content={data.data.data} onChange={setAlert} />);
  const onSuccess = (data) => setAlert(<Success content={data.data.data} onChange={setAlert} />)
  const {user} = useAuth();

  const defaultValues = {
    ...initialValues,
    userName: user.userId
  };

  const form = useForm({
    defaultValues: defaultValues,
    resolver: yupResolver(changePasswordValidation),
  });

  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitting },
    setValue,
    reset,
  } = form;

  const infoProps = {
    control,
    errors,
    setValue,
    formRender,
  };

  const onSubmit = async (data) => {
    try {
      setLoading(true)
      const res = await changePassword(data.userName, data.password, data.newPassword);
      if (res) {
        if (res.status === 200 && res.data.code === 200) {
          setLoading(false)
          onSuccess(res)
          reset();
        } else {
          setLoading(false)
          onError(res);
        }
      }
    } catch (err) {
      setLoading(false)
      onError(err)
    }
    
  };

  return (
    <Layout>
      {loading && <LoadingDialog/>}
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <ChangePasswordInfo {...infoProps} />
        <SubmitButton label="submit" url="/" />
      </form>
    </Layout>
  );
}

export default ChangeUserPassword;
